import './styles.scss'
import React, { useState, useEffect } from 'react'
import { Button, Col, Container, Row } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'
import { userIsAuthorized } from '../../../routes/Authorizer/helpers'
import { apiPayment } from 'api'
import lodashGet from 'lodash.get'

import managementActions from 'routes/Dashboard/Management/ManagementActions'
import Nixi1Spinner from 'components/Nixi1Spinner'

/**
 *
 * @param {object} props
 * @param {string} props.redirectUrl
 */
function PaymentMethodEdit(props) {
  const { redirectUrl } = props

  const match = useRouteMatch()

  const company = useSelector(store => store.companies)
  const currentSession = useSelector(store => store.user)

  const [status, setStatus] = useState({ loading: true, redsys: {} })

  useEffect(() => {
    const url = `${window.location.origin}#${redirectUrl || match.url}`

    apiPayment
      .getRedsysForm({ successURL: url, errorURL: url })
      .then(({ data, status }) => {
        if (status === 200) {
          setStatus({ loading: false, redsys: data.results })
        }
      })
      .catch((err) => console.error(err))
  }, [redirectUrl, match.url])

  const { loading, redsys } = status

  const paymentReferences = lodashGet(company, 'paymentReferences', [])
  const existReferences = paymentReferences.length > 0

  return (
    <Container>
      {loading ? (
        <Nixi1Spinner width='25px' height='25px' />
      ) : (
        <form acceptCharset='utf-8' action={redsys.redsys_url} method='post'>
          <Row>
            <Col>
              <div className='section-title'>{I18n.t('dashboard_payment-method')}</div>
              {!existReferences && <div className='section-subtitle'>{I18n.t('company_payment_information')}</div>}
            </Col>
          </Row>

          <input type='hidden' name='Ds_MerchantParameters' value={redsys.Ds_MerchantParameters} />
          <input type='hidden' name='Ds_SignatureVersion' value={redsys.Ds_SignatureVersion} />
          <input type='hidden' name='Ds_Signature' value={redsys.Ds_Signature} />

          {userIsAuthorized({
            capability: managementActions[currentSession.role].companies,
            action: 'UPDATE',
          }) && (
            <>
              {existReferences ? (
                <Row className='mt-3'>
                  <Col>
                    <div className='credit-card-info'>{I18n.t('company_creditCardInfo')}</div>
                    <div className='credit-card-info-data'>
                      {I18n.t('credit_card_expiry_date')} <span>{paymentReferences[0].expiryDate}</span>
                    </div>
                  </Col>
                </Row>
              ) : null}

              <Row className='mt-3'>
                <Col>
                  <Button color='primary' type='submit'>
                    {I18n.t(existReferences ? 'dashboard_modify-payment-method' : 'dashboard_add-payment-method')}
                  </Button>
                </Col>
              </Row>
            </>
          )}
        </form>
      )}
    </Container>
  )
}

export default PaymentMethodEdit
